<template>
	<div class="statuses-container" v-if="licenseAlertVisible">
		<div class="statuses-floater mouse-pointer" @click="onClick">
			<WarningFilled class="license-alert-icon"/> {{ $t('license.alert') }}
		</div>
	</div>
</template>

<script>
import { WarningFilled } from '@ant-design/icons-vue';

import { useLicenseStore } from '@/stores/licenseStore';
import { licenseAlertVisible } from '@/state/licenseAlert';

export default {
	components: {
		WarningFilled,
	},
	emits: ['click'],
	setup(props, { emit }) {
		const licenseStore = useLicenseStore();
		const onClick = () => {
			emit('click');
			licenseStore.refresh();
		};

		return {
			licenseAlertVisible,
			onClick,
		}
	},
}
</script>
<style scoped>
@import '@/assets/floaters.css';

.license-alert-icon {
	color: #F6AE13;
	margin-inline-end: 4px;
}
</style>
